import type { RecipeMainIngredient } from '@apps/main/modules/recipe/ingredients';

import type { ConnectionType } from '@libs/maps';
import type { MonthIndex } from '@libs/sembo-dates';
import type {
  AvailabilityOrder,
  Landing,
  RecipeMetaData,
  Pax,
} from '@libs/trip-planner-interfaces';

export enum TripPlannerPage {
  BaseURL = 'plan',
  TripOverview = 'tripOverview',
  TripOverviewPrint = 'tripOverviewPrint',
  FlightList = 'flights',
  FerryList = 'ferry',
  HotelSelection = 'hotelSelection',
  ActivitySelection = 'activitySelection',
  HotelDetailsInHotelSelection = 'hotelDetailsInHotelSelection',
  HotelDetails = 'hotelDetails',
  ActivityDetailsInActivitySelection = 'activityDetailsInActivitySelection',
  ActivityDetails = 'activityDetails',
  CarTrip = 'carTrip',
}

// NOTE: This parameter is used when some errors further down the funner occured
// and user is redirected back to trip planner to try again.
export const enum ExternalErrorQueryParamValue {
  // NOTE: This variant is used by book team to redirect user from checkout, when booking failed.
  BookingFailed = 'booking-failed',
}

export const enum ModalQueryParamValue {
  Pax = 'pax',
}

// NOTE: This parameter is used when user is redirected to trip planner to to buy additional products.
export const enum CustomerOriginQueryParamValue {
  // NOTE: This varian is used by shop team to upsell accommodation for users who already bought transport only.
  BookingPage = 'booking-page',
}

export interface TripPlannerQueryParams {
  initialIngredients: RecipeMainIngredient[];
  initialPax: Pax;
  initialSelectedDate?: Date;
  initialSelectedMonth?: MonthIndex;
  initialSuggestionSortType?: AvailabilityOrder;
  landing?: Landing;
  initialMetaRooms?: string[];
  sessionId?: string;
  initialRedirectionToken?: string;
  returnTransport?: ConnectionType;
  metaData?: RecipeMetaData;
  aiTripId?: string;
  publishedTripId?: string;
  modal?: ModalQueryParamValue;
  externalError?: ExternalErrorQueryParamValue;
  customerOrigin?: CustomerOriginQueryParamValue;
  searchForPackageRates?: boolean | null;
}

export function mapFullPathToTripPlannerPage(
  fullPath: string
): TripPlannerPage | undefined {
  if (fullPath.includes('travel/plan/overview')) {
    return TripPlannerPage.TripOverview;
  }
  if (fullPath.includes('travel/plan/hotel-selection')) {
    return TripPlannerPage.HotelSelection;
  }
  if (fullPath.includes('travel/plan/hotel-details')) {
    return TripPlannerPage.HotelDetails;
  }
  if (fullPath.includes('travel/plan/flights')) {
    return TripPlannerPage.FlightList;
  }
  if (fullPath.includes('travel/plan/ferry')) {
    return TripPlannerPage.FerryList;
  }
  if (fullPath.includes('travel/plan/activity-selection')) {
    return TripPlannerPage.ActivitySelection;
  }
  if (fullPath.includes('travel/plan/activity-details')) {
    return TripPlannerPage.ActivityDetails;
  }
  if (fullPath.includes('travel/plan/car-trip')) {
    return TripPlannerPage.CarTrip;
  }

  return undefined;
}
